import React, { useEffect, useState, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomGrid from "../../components/common/CustomGrid/CustomGrid";
import { fetchEquipmentCuts } from "../../redux/slice/CompanySlice/CompanySlice";
import Loader from "../Loader/Loader";
import { BreadcrumbsContext } from "../../context/BcrumbsContextProvider";
import * as XLSX from "xlsx";
import {
    CreateEquipmentCutExcel
} from "../../Apis/Sites/SitesApis";
import { SnackBarContext } from "../../context/SnackBarContext";
import { FaTrash } from "react-icons/fa";

function CompanyEqView() {
    const dispatch = useDispatch();
    const { EquipmentCuts, status } = useSelector((state) => state?.Companies);
    const [filterData, setFilterData] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const data = location.state._id;
    const { setBreadcrumbsItems } = useContext(BreadcrumbsContext);
    const { setsnackBarData } = useContext(SnackBarContext);
    const [columns, setColumns] = useState([]);

    const fileInputRef = useRef(null);

    const handleBreadcrumbs = () => {
        setBreadcrumbsItems([
            {
                id: 1,
                url: "/companies",
                name: "Companies",
            },
            {
                id: 2,
                url: "/companies/equipmentCut-view",
                name: "Equipment View",
            },
        ]);
    };

    useEffect(() => {
        handleBreadcrumbs();
        return () => {
            setBreadcrumbsItems([]);
        };
    }, [setBreadcrumbsItems]);

    useEffect(() => {
        dispatch(fetchEquipmentCuts(data));
    }, [dispatch, data]);

    useEffect(() => {
        // let sourceData = [];

        // if (type === "equipment") {
        //   sourceData = SitesDetail;
        // } else if (type === "equipmentWorking") {
        //   sourceData = SiteDetail2;
        // } else if (type === "componentWorking") {
        //   sourceData = SiteDetail3;
        // }

        const arr =
            EquipmentCuts?.map((item, idx) => ({
                idx: idx + 1,
                ...item,
            })) || [];

        setFilterData(arr);
    }, [EquipmentCuts]);


    const columnsEquWork = [
        {
            Header: "SIZE",
            accessor: "size",
            width: 120,
        },
        { Header: "COMP DESCR.", accessor: "diameter", minWidth: 120 },
        { Header: "NOM", accessor: "orgThickness", minWidth: 120 },
        { Header: "ID", accessor: "id", minWidth: 120 },
        { Header: "OD", accessor: "od", minWidth: 120 },
        { Header: "EFF.", accessor: "efficiency", minWidth: 150 },
        { Header: "SPECIMATL", accessor: "material", minWidth: 150 },


    ];

    const exportToExcel = () => {
        if (!columns || columns.length === 0) return;
        const headers = columns.map((column) => column.Header);
        const ws = XLSX.utils.aoa_to_sheet([headers]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Equipment Data");
        XLSX.writeFile(wb, "EquipmentData.xlsx");
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (!file) {
            setSelectedFile(null);
            setFileName("");
            return;
        }
        setSelectedFile(file);
        setFileName(file.name);
        e.target.value = "";
    };

    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    const handleUploadSubmit = async () => {
        if (selectedFile) {
            setLoading(true);
            const formData = new FormData();
            formData.append("excelfile", selectedFile);
            formData.append("company", data);
            try {
                let response = "";
                response = await CreateEquipmentCutExcel(formData);

                if (response && response.success) {
                    dispatch(fetchEquipmentCuts(data));
                    setsnackBarData({
                        openToast: true,
                        type: response.snackBarData?.type || "success",
                        message: response.msg || "File uploaded successfully.",
                    });
                } else {
                    setsnackBarData({
                        openToast: true,
                        type: "error",
                        message: response?.msg || "Failed to upload the file.",
                    });
                }
            } catch (error) {
                console.error("Error uploading file:", error);
                setsnackBarData({
                    type: "error",
                    message: "Error uploading file.",
                    openToast: true,
                });
            } finally {
                setLoading(false);
                setSelectedFile(null);
                setFileName("");
                fileInputRef.current.value = "";
            }
        } else {
            setsnackBarData({
                type: "error",
                message: "Please select a file to upload.",
                openToast: true,
            });
        }
    };

    const handleClearFile = () => {
        setSelectedFile(null);
        setFileName("");
        fileInputRef.current.value = "";
    };

    useEffect(() => {
        setColumns(columnsEquWork);

    }, []);

    return (
        <>
            <div className="mb-2 d-flex justify-content-between align-items-center">
                <button
                    className="btn btn-primary"
                    style={{ marginRight: "20px" }}
                    onClick={exportToExcel}
                    disabled={loading}
                >
                    Extract to Excel
                </button>
                <div className="d-flex gap-2" style={{ justifyContent: "flex-end" }}>
                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                        ref={fileInputRef}
                    />
                    <button
                        className="btn btn-secondary"
                        onClick={handleUploadClick}
                        disabled={loading}
                    >
                        Upload Excel File
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={handleUploadSubmit}
                        disabled={loading || selectedFile == null}
                    >
                        Submit
                    </button>
                </div>
            </div>
            {fileName && (
                <div
                    className="mb-3 d-flex  gap-2"
                    style={{
                        textAlign: "right",
                        justifyContent: "end",
                        alignItems: "center",
                    }}
                >
                    <strong>Selected File:</strong>
                    <button type="button" className="btn btn-secondary">
                        {fileName}
                    </button>
                    <button
                        aria-label="clear"
                        onClick={handleClearFile}
                        size="small"
                        style={{ marginLeft: "8px" }}
                    >
                        <FaTrash />
                    </button>
                </div>
            )}
            {status === "loading" || loading ? (
                <div className="text-center">
                    <Loader />
                </div>
            ) : (
                <div>
                    <p style={{ fontWeight: 600, marginTop: "5px" }}>
                        Equipments Detail
                    </p>
                    <CustomGrid columns={columns} data={filterData} />
                </div>
            )}
        </>
    );
}

export default CompanyEqView;
